import { render, staticRenderFns } from "./QuestionCriteriaFormComponent.vue?vue&type=template&id=7404612f"
import script from "./QuestionCriteriaFormComponent.vue?vue&type=script&lang=js"
export * from "./QuestionCriteriaFormComponent.vue?vue&type=script&lang=js"
import style0 from "./QuestionCriteriaFormComponent.vue?vue&type=style&index=0&id=7404612f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports